var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"nitrozen-badge"}},[_c('div',{staticClass:"nitrozen-badge",class:[_vm.addClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }